<script setup lang="ts">
interface WeOfferInfoBackEnd {
  title: string
  description: string
  imagePath: string
}

defineProps<{
  data?: WeOfferInfoBackEnd
}>()
</script>

<template>
  <div class="z-20 xs:mt-6">
    <img
      :src="`/services/${data?.imagePath}`"
      class="mx-auto mb-16 h-[355px] w-[355px] lg:hidden"
      alt="We offer details BE"
    />
    <div class="xs:text-justify lg:text-left">
      <WComponentTitle class="mb-4">{{ data?.title }}</WComponentTitle>
      <WParagraph> {{ data?.description }} </WParagraph>
    </div>
  </div>
</template>
